import {Utils} from '../support/utils';
import {AdLoader} from '../services/adLoader';
import {Interstital} from "../models/intestetial";
import {Banner} from "../models/banner";
import {Thumbnail} from "../models/tumbnail";
import {Error} from "../models/error";
import {IFRAME_EVENTS} from "../config/constants";

export class App {

    static instance;
    static ads = {};

    constructor(context, withMediation) {
        if(this.constructor.getInstance()){
            return this.constructor.getInstance();
        }

        this.withMediation = withMediation;
        this.context = context;
        this.totalAdds = 0;
        this.adLoader = new AdLoader(context);
        this.bluestackUserId = Utils.getCookie('maduserid');
        this.messageCallbacks = {};
        this.instantiateMessagePosting();
        this.constructor.setInstance(this);
        this.constructor.ads = {};
    }

    loadThumnbail(parameters, config = {}) {
        parameters['format'] = 'thumbnail';
        if (config['size'] && typeof config['size'] === "object") {
            parameters['size'] = config['size'];
        }
        if (config['position'] && typeof config['position'] === "object") {
            parameters['position'] = config['position'];
        }
        this.load(parameters);
    }

    loadSquare(parameters) {
        parameters['format'] = 'square';
        this.load(parameters);
    }

    loadBanner(parameters) {
        parameters['format'] = 'banner';
        this.load(parameters);
    }

    loadInterstital(parameters) {
        parameters['format'] = 'interstitial';
        this.load(parameters);
    }

    load(parameters) {
        this.totalAdds++;
        const containerId = 'global_ad_id' + this.totalAdds;
        parameters.containerId = containerId;
        parameters.withMediation = this.withMediation;
        parameters.isAbsolute = true;
        let container = document.createElement('div');
        container.id = containerId;
        if (parameters.asyntagid) {
            const parentContainer = this.context.document.getElementById(parameters.asyntagid);
            if (parentContainer) {
                parameters.isAbsolute = false;
                parameters.parentContainer = parentContainer;
                parentContainer.innerHTML = container.outerHTML;
            }
        }

        if (parameters.isAbsolute) {
            this.context.document.body.append(container);
        }

        container = this.context.document.getElementById(containerId);

        this.adLoader.get(parameters).then(data => {
            data.text().then(x => {
                let script = document.createElement("script");
                script.type = "text/javascript";
                script.innerHTML = x;
                container.appendChild(script);

                const ad = window[containerId];
                if (parameters.format === 'thumbnail') {
                    ad.type = 'thumbnail';
                }

                if (ad.error) {
                    ad.type = 'error';
                }

                if (!parameters.target) {
                    parameters.target = '';
                }

                this.setUserCookies(ad);

                let adClass;
                switch (ad.type) {
                    case 'error':
                        adClass = Error;
                        break;
                    case 'interstitial':
                        adClass = Interstital;
                        break;
                    case 'thumbnail':
                        adClass = Thumbnail;
                        break;
                    default:
                        adClass = Banner;
                        break;
                }

                this.constructor.ads[containerId] = new adClass(this.context, containerId, parameters, ad);
                this.constructor.ads[containerId].build();

                if (parameters["prependclickcontent"]) {
                    this.prependClickContent(container, parameters);
                }
                if (parameters["trackingpixelurl"]) {
                    this.trackingPixelUrk(parameters);
                }
            });
        }).catch( er => {
            console.error(er);
        })
    }

    setUserCookies(ad) {
        if (!this.bluestackUserId && ad.userid) {
            Utils.setCookie('maduserid', ad.userid, 390, '/', '')
        }

        let host = location.host;
        let seenAdKey = 'seenad[' + ad['adid'] + ']';
        let seenAdValue = Date.now() / 1000 | 0;
        if (host.split('.').length === 1) {
            Utils.setCookie(seenAdKey, seenAdValue, 2, '/')
        } else {
            let domainParts = host.split('.');
            domainParts.shift();
            let domain = '.' + domainParts.join('.');
            Utils.setCookie(seenAdKey, seenAdValue, 2, '/', domain);
        }

    }

    prependClickContent(container, parameters) {
        const links = container.getElementsByTagName("a");
        for (let i  = 0; i < links.length; ++iter) {
            let link = links[iter], original = link.href;
            link.href = parameters['prependclickcontent'] + original;
        }
    }

    trackingPixelUrk(parameters) {
        let img = new Image();
        img.src = parameters.trackingpixelurl + (parameters.trackingpixelurl.indexOf('?') ? '&' : '?') + Math.random();
    }

    instantiateMessagePosting() {
        let the = this;
        const message = function (e) {
            let data = e.data;
            if (data.message && data.adId && typeof data.message == "string") {
                if (!the.constructor.ads[data.adId]) {
                    return;
                }
                switch (data.message) {
                    case IFRAME_EVENTS.CLOSE:
                        the.constructor.ads[data.adId].close();
                        break;
                    case IFRAME_EVENTS.HIDE:
                        the.constructor.ads[data.adId].hide();
                        break;
                    case IFRAME_EVENTS.SHOW:
                        the.constructor.ads[data.adId].show();
                        break;
                    default:
                        console.log("Unknown command");
                        break;
                }
            }
        }
        this.context.addEventListener("message", message, false);
    }

    static setInstance(instance) {
        this.instance = instance;
    }

    static getInstance() {
        return this.instance;
    }
}